// import React from 'react'
import { Box } from 'grommet'
// import Adthrive from '../Adthrive'
import styled, { css } from 'styled-components'
// import { rgba } from 'polished'
import { FullScreen as FullScreenG } from 'react-full-screen'

import { device } from '../../theme/device'
// import { css } from 'styled-components'

// export const TurntableBox = styled(Box)`
//   position: relative;
//   min-height: ${props => props.minHeight};
//   min-width: 600px;
//   @media (max-width: 1000px) {
//     min-width: 520px;
//   }
//   @media (max-width: 555px) {
//     min-width: 0px;
//   }
// `

//desktop squeeze to mobile view, the height has extra 15px (scrollbar width)
export const TurntableBox = styled(Box)`
  position: relative;
  height: ${props => (props.fullScreenActive ? props.minHeight : '600px')};
  min-height: 600px;
  min-width: 600px;
  @media screen and (max-width: 635px) and (orientation: portrait) {
    width: calc(100vw - 20px);
    height: calc(100vw - 20px);
    min-height: 0;
    min-width: 0;
  }
`

// export const TurntablePlaceholder = styled(Box)`
//   position: relative;
//   height: 600px;
//   width: 600px;
//   @media screen and (max-width: 635px) and (orientation: portrait) {
//     width: calc(100vw - 20px);
//     height: calc(100vw - 20px);
//   }
// `

export const BGContainer = styled(Box)`
  position: relative;
  background-color: ${props => props.bgColor};
`

export const BGContainerImage = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: ${props => props.bgImage};
  opacity: 0.3;
`

const ContainerToolFullScreenStyle = css`
  width: 100%;
  margin: 0 0rem;
  max-width: 100%;
`

const ContainerToolNormalStyle = css`
  max-width: 140rem;
  align-self: center;
  width: calc(100% - 7rem);
  margin-left: 3.5rem;
  margin-right: 3.5rem;
  z-index: 1;
  /* margin: 0rem 3.5rem 3.5rem; */
`

export const ContainerTool = styled(Box)`
  ${props =>
    props.fullScreenActive
      ? ContainerToolFullScreenStyle
      : ContainerToolNormalStyle}

  @media (max-width: 900px) {
    width: calc(100% - 2rem);
    margin-left: 1rem;
    margin-right: 1rem;
    /* margin-bottom: 3rem; */
    /* margin: 0rem 1rem 3rem; */
  }
  /* max-width: 140rem; */
  /* align-self: center;
  width: 100%; */
  /* margin: 0rem 3.5rem 3.5rem;/ */
  /* @media (max-width: 900px) {
    width: calc(100% - 2rem);
    margin: 0rem 1rem 3rem;
  } */
`

export const WheelWhiteBox = styled(Box)`
  overflow: hidden;
  position: relative;
  justify-content: center;
  height: ${props => (props.fullScreenActive ? 'calc(100vh - 10rem)' : `auto`)};
  padding: ${props => (props.fullScreenActive ? '1.5rem 0rem' : `3rem 0rem`)};
  @media ${device.medium} {
    padding: 1rem 0rem 2.5rem;
  }
  @media (max-width: 1152px) {
    ${props =>
      props.fullScreenActive &&
      css`
        justify-content: center;
      `}
  }
  ${props =>
    !!props.bgImage &&
    css`
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
      background-image: url(${props => props.bgImage});
    `}
`
export const WheelBox = styled(Box)`
  position: relative;
  width: ${props =>
    props.fullScreenActive ? 'calc(100vh - 10rem - 3rem)' : '120rem'};
  @media (max-width: 1152px) {
    ${props =>
      props.fullScreenActive &&
      css`
        width: 60rem;
        height: 60rem;
      `}
  }
`

export const FullScreen = styled(FullScreenG)`
  display: flex;
  align-self: stretch;
  align-items: stretch;
  flex-direction: column;
  background-color: ${props => (props.handle.active ? '#000' : 'transparent')};
`

export const WheelPlaceholder = styled(Box)`
  position: absolute;
  top: 50%; /* position the top  edge of the element at the middle of the parent */
  left: 50%; /* position the left edge of the element at the middle of the parent */
  transform: translate(-50%, -50%);
  width: calc(100% - 20px);
  max-width: ${props => `${props.size - 20}px`};
  /* max-width: 580px; */
  background-color: ${props => props.theme.global.colors.wheelPlaceholder};
  /* max-width: 580px;
  max-height: 580px; */
  box-shadow: 0px 0px 5px 2px
    ${props => props.theme.global.colors.wheelPlaceholder};
  border-radius: 50%;

  &::before {
    content: '';
    padding-top: 100%;
  }
`

// export const WheelPlaceholder = styled(Box)`
//   position: absolute;
//   top: 50%; /* position the top  edge of the element at the middle of the parent */
//   left: 50%; /* position the left edge of the element at the middle of the parent */
//   transform: translate(-50%, -50%);
//   width: calc(100% - 60px);
//   /* max-width: ${props => `${props.size - 20}px`}; */
//   /* max-width: 580px; */
//   background-color: ${props => props.theme.global.colors.border};
//   /* max-width: 580px;
//   max-height: 580px; */
//   box-shadow: 0px 0px 5px 2px
//     ${props => props.theme.global.colors.wheelPlaceholder};
//   border-radius: 50%;

//   &::before {
//     content: '';
//     padding-top: 100%;
//   }
// `
